import React from 'react';
import { Card, Table, Typography } from 'antd';

const { Text } = Typography;

interface GroupPivotData {
  cols: Array<{ key: string; name: string }>;
  rows: any[];
}

interface CategorySummaryCardProps {
  loading: boolean;
  groupPivot: GroupPivotData;
  inspectorById: Map<number, any>;
  effortByInspector: Map<number, Record<string, number>>;
  minutesToDays: (minutes: number) => string;
  accordionOpen?: boolean;
  onAccordionToggle?: () => void;
}

const CategorySummaryCard: React.FC<CategorySummaryCardProps> = ({
  loading,
  groupPivot,
  inspectorById,
  effortByInspector,
  minutesToDays,
  accordionOpen,
  onAccordionToggle,
}) => (
  <Card
    title={
      typeof accordionOpen === 'boolean' && typeof onAccordionToggle === 'function' ? (
        <div
          role='button'
          tabIndex={0}
          onClick={onAccordionToggle}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              onAccordionToggle?.();
            }
          }}
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
        >
          <span>Yasal Bildirim Detayları</span>
          <span>{accordionOpen ? '-' : '+'}</span>
        </div>
      ) : (
        'Yasal Bildirim Detayları'
      )
    }
    className='br-30px mt-16px'
    loading={loading}
  >
    {(typeof accordionOpen !== 'boolean' || accordionOpen) && groupPivot.rows.length ? (
      <Table
        dataSource={groupPivot.rows}
        columns={[
          {
            title: 'P.K.M Uzmanı',
            key: 'inspectorName',
            render: (_: unknown, record: any) => {
              const uid = Number(record?.key);
              const name = record?.inspectorName || '';
              const inspector = inspectorById.get(uid) || {};
              const identityNumber: string | undefined = inspector?.identityNumber || inspector?.account?.identityNumber;
              const efforts = effortByInspector.get(uid) || {};
              const effortParts: string[] = Object.entries(efforts)
                .map(([key, value]) => {
                  const offeringName = key.split('::')[1] || key;
                  return { name: offeringName, minutes: Number(value) || 0 };
                })
                .filter((entry) => entry.minutes > 0)
                .sort((a, b) => a.name.localeCompare(b.name, 'tr'))
                .map((entry) => `${entry.name}: ${minutesToDays(entry.minutes)} gün`);

              return (
                <span>
                  <span style={{ fontWeight: 700 }}>{name}</span>
                  {effortParts.length > 0 ? (
                    <span style={{ marginLeft: 6, color: '#595959' }}>({effortParts.join(', ')})</span>
                  ) : null}
                  <br />
                  {identityNumber ? (
                    <span style={{ color: '#595959' }}>
                      <span style={{ fontWeight: 700 }}>TCKN:</span> {` ${identityNumber}`}
                    </span>
                  ) : null}
                </span>
              );
            },
          },
          ...groupPivot.cols
            .filter((column) => column.key !== 'no-group' && (column.name || '').toString() !== 'Kategori Yok')
            .map((column) => ({
              title: column.name,
              dataIndex: column.key,
              key: column.key,
              align: 'center' as const,
            })),
        ]}
        pagination={false}
        rowKey='key'
        size='small'
      />
    ) : (typeof accordionOpen !== 'boolean' || accordionOpen) ? (
      <Text>Henüz seçim yok.</Text>
    ) : null}
  </Card>
);

export default CategorySummaryCard;
